import { render } from "./ContactModal.vue?vue&type=template&id=fc21e602"
import script from "./ContactModal.vue?vue&type=script&lang=js"
export * from "./ContactModal.vue?vue&type=script&lang=js"

import "./ContactModal.vue?vue&type=style&index=0&id=fc21e602&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__